import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { services } from "../../mock/mock";

export default function Services() {
  return (
    <section id="services" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div>
            <div className="section-label mb-6">What I Do</div>
            <h2 className="font-display text-[42px] md:text-[64px] leading-[1.02] tracking-[-0.02em] max-w-3xl">
              Delivering <span className="italic sage-text">excellence</span> through experience.
            </h2>
          </div>
          <p className="max-w-sm text-[15px] leading-[1.7] text-[var(--text-dim)]">
            Years of hands-on expertise crafting innovative, high-quality digital solutions that drive measurable, lasting success.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[1px] bg-white/5 rounded-2xl overflow-hidden border border-white/5">
          {services.map((s, i) => (
            <motion.article key={s.num}
              initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
              className="group relative bg-[var(--bg)] p-7 md:p-8 flex flex-col min-h-[260px] hover:bg-[#0f110f] transition-colors">
              <div className="flex items-start justify-between">
                <span className="mono text-[11px] tracking-[0.2em] uppercase text-[var(--muted)]">{s.num}</span>
                <ArrowUpRight size={20} className="text-[var(--text-dim)] group-hover:text-[var(--sage)] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all" />
              </div>

              <h3 className="mt-8 font-display text-[28px] md:text-[30px] leading-tight tracking-[-0.01em]">{s.title}</h3>
              <p className="mt-3 text-[14.5px] leading-[1.7] text-[var(--text-dim)]">{s.desc}</p>

              <div className="mt-auto pt-6 flex flex-wrap gap-2">
                {s.tags.map((t) => (
                  <span key={t} className="mono text-[10px] tracking-[0.14em] uppercase text-[var(--text-dim)] border border-white/10 rounded-full px-2.5 py-1">
                    {t}
                  </span>
                ))}
              </div>

              <span className="pointer-events-none absolute inset-x-8 bottom-0 h-px bg-gradient-to-r from-transparent via-[var(--sage)] to-transparent scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-500" />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
